import * as React from 'react'
import { cn } from '../../lib/utils'

export interface FormInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean
}

export const FormInput = React.forwardRef<HTMLInputElement, FormInputProps>(
  ({ className, type, error, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-10 w-full rounded-md border bg-white px-3 py-2 text-sm transition-colors placeholder:text-gray-500 focus:border-admin-blue focus:outline-none focus:ring-1 focus:ring-admin-blue disabled:cursor-not-allowed disabled:opacity-50',
          // Estilos específicos para inputs de fecha
          type === 'date' && [
            '[&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:right-2 [&::-webkit-calendar-picker-indicator]:top-1/2 [&::-webkit-calendar-picker-indicator]:-translate-y-1/2',
            '[&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-webkit-calendar-picker-indicator]:opacity-70 [&::-webkit-calendar-picker-indicator]:hover:opacity-100',
            '[&::-webkit-datetime-edit]:flex-1 [&::-webkit-datetime-edit]:text-left',
            '[&::-webkit-datetime-edit-text]:text-gray-500',
            'relative pr-10', // Añadir padding derecho para hacer espacio al icono
          ],
          error
            ? 'border-red-500 focus:border-red-500 focus:ring-red-500'
            : 'border-gray-300 hover:border-gray-400',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

FormInput.displayName = 'FormInput'
